export default __webpack_public_path__ + "static/media/downloadIcon.bb522e06.svg";